/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubmitterType } from './SubmitterType';
import {
    SubmitterTypeFromJSON,
    SubmitterTypeFromJSONTyped,
    SubmitterTypeToJSON,
    SubmitterTypeToJSONTyped,
} from './SubmitterType';
import type { EvidenceRequirement } from './EvidenceRequirement';
import {
    EvidenceRequirementFromJSON,
    EvidenceRequirementFromJSONTyped,
    EvidenceRequirementToJSON,
    EvidenceRequirementToJSONTyped,
} from './EvidenceRequirement';

/**
 * 
 * @export
 * @interface IScoringResponseConfirmation
 */
export interface IScoringResponseConfirmation {
    /**
     * 
     * @type {Array<SubmitterType>}
     * @memberof IScoringResponseConfirmation
     */
    submitters: Array<SubmitterType>;
    /**
     * 
     * @type {boolean}
     * @memberof IScoringResponseConfirmation
     */
    requireOpponentConfirmation: boolean;
    /**
     * 
     * @type {Array<EvidenceRequirement>}
     * @memberof IScoringResponseConfirmation
     */
    evidenceRequired: Array<EvidenceRequirement>;
    /**
     * Formatted timeout for display (e.g., "30 minutes")
     * @type {string}
     * @memberof IScoringResponseConfirmation
     */
    confirmationTimeoutDisplay?: string;
}

/**
 * Check if a given object implements the IScoringResponseConfirmation interface.
 */
export function instanceOfIScoringResponseConfirmation(value: object): value is IScoringResponseConfirmation {
    if (!('submitters' in value) || value['submitters'] === undefined) return false;
    if (!('requireOpponentConfirmation' in value) || value['requireOpponentConfirmation'] === undefined) return false;
    if (!('evidenceRequired' in value) || value['evidenceRequired'] === undefined) return false;
    return true;
}

export function IScoringResponseConfirmationFromJSON(json: any): IScoringResponseConfirmation {
    return IScoringResponseConfirmationFromJSONTyped(json, false);
}

export function IScoringResponseConfirmationFromJSONTyped(json: any, ignoreDiscriminator: boolean): IScoringResponseConfirmation {
    if (json == null) {
        return json;
    }
    return {
        
        'submitters': ((json['submitters'] as Array<any>).map(SubmitterTypeFromJSON)),
        'requireOpponentConfirmation': json['requireOpponentConfirmation'],
        'evidenceRequired': ((json['evidenceRequired'] as Array<any>).map(EvidenceRequirementFromJSON)),
        'confirmationTimeoutDisplay': json['confirmationTimeoutDisplay'] == null ? undefined : json['confirmationTimeoutDisplay'],
    };
}

export function IScoringResponseConfirmationToJSON(json: any): IScoringResponseConfirmation {
    return IScoringResponseConfirmationToJSONTyped(json, false);
}

export function IScoringResponseConfirmationToJSONTyped(value?: IScoringResponseConfirmation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submitters': ((value['submitters'] as Array<any>).map(SubmitterTypeToJSON)),
        'requireOpponentConfirmation': value['requireOpponentConfirmation'],
        'evidenceRequired': ((value['evidenceRequired'] as Array<any>).map(EvidenceRequirementToJSON)),
        'confirmationTimeoutDisplay': value['confirmationTimeoutDisplay'],
    };
}

